export default __webpack_public_path__ + "valid-records-dark-icon.svg";